<template>
  <div class="application_draft">
    <div class="top">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>我的申请草稿</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="main">
      <div class="search">
        <div class="search_son">
          <span class="input">委托单位</span>
          <el-input
            size="mini"
            placeholder="请输入关键字"
            clearable
            v-model="form.company"
          ></el-input>
        </div>
        <div class="search_son">
          <span class="input">产品名称</span>
          <el-input
            size="mini"
            placeholder="请输入产品名称"
            clearable
            v-model="form.name"
          ></el-input>
        </div>
        <div class="search_son btn">
          <el-button type="primary" round size="mini" @click="search"
            >查询</el-button
          >
        </div>
        <div class="search_son refresh" @click="refresh">
          <i class="el-icon-refresh"></i>刷新-共{{ total }}条数据
        </div>
      </div>
      <el-table
        ref="multipleTable"
        :data="tableData"
        border
        highlight-current-row
        tooltip-effect="dark"
        style="width: 100%"
      >
        <el-table-column type="index" width="50" label="序号" align="center">
        </el-table-column>
        <!-- <el-table-column label="申请编号" align="center">
          <template slot-scope="scope">{{ scope.row.apply_number }}</template>
        </el-table-column> -->
        <el-table-column label="委托单位" align="center">
          <template slot-scope="scope">{{
            scope.row.enterprise_client_name
          }}</template>
        </el-table-column>
        <el-table-column label="生产商" align="center">
          <template slot-scope="scope">{{
            scope.row.enterprise_manufacturer_name
          }}</template> </el-table-column
        ><el-table-column label="检测产品" align="center">
          <template slot-scope="scope">{{ scope.row.product_name }}</template>
        </el-table-column>
        <el-table-column label="产品类型" align="center">
          <template slot-scope="scope">{{ scope.row.product_model }}</template>
        </el-table-column>
        <el-table-column label="合同类型" align="center">
          <template slot-scope="scope">{{
            scope.row.business_type == 1
              ? "家电委托合同"
              : scope.row.business_type == 3
              ? "化学委托合同"
              : scope.row.business_type == 5
              ? "CVC自愿性认证合同"
              : ""
          }}</template>
        </el-table-column>
        <el-table-column label="时间" align="center">
          <template slot-scope="scope"
            ><span v-if="scope.row.utime">{{
              scope.row.utime | formatDate(scope.row.utime)
            }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="160" align="center">
          <template slot-scope="scope">
            <span class="look" @click="toDetails(scope.row)">编辑</span>
          </template>
        </el-table-column>
      </el-table>
      <div class="page_footer">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="npage"
          :page-size="pagesize"
          layout="total, prev, pager, next,jumper"
          background
          :total="total"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { formatDate } from "../../filters/filters.js";
import { httpApplycopy } from "../../utils/myapplication";
export default {
  data() {
    return {
      npage: 1, //当前页
      pagesize: 10, //每页显示条数
      total: 0, //总条数
      form: {
        company: "",
        name: "",
      },
      tableData: [],
    };
  },
  methods: {
    //查询
    search() {
      this._httpApplycopy(1, this.pagesize, this.form.company, this.form.name);
    },
    //刷新
    refresh() {
      this.form.company = "";
      this.form.name = "";
      this._httpApplycopy(1, this.pagesize, this.form.company, this.form.name);
    },
    //分页
    handleSizeChange(val) {
      this.pagesize = val;
      this._httpApplycopy(
        this.npage,
        this.pagesize,
        this.form.company,
        this.form.name
      );
    },
    handleCurrentChange(val) {
      this.npage = val;
      this._httpApplycopy(
        this.npage,
        this.pagesize,
        this.form.company,
        this.form.name
      );
    },
    //查看详情
    toDetails(row) {
      console.log(row);
      if (row.business_type == 1) {
        this.$router.push({
          path: "/applicationFormFillInHouse",
          query: { type: 1, id: row.id },
        });
      } else if (row.business_type == 3) {
        this.$router.push({
          path: "/applicationFormFillInHouse",
          query: { type: 2, id: row.id },
        });
      } else if (row.business_type == 5) {
        this.$router.push({
          path: "/applicationFormFillInHouse",
          query: { type: 3, id: row.id },
        });
      }
    },
    //草稿列表
    _httpApplycopy(page, pagesize, enterprise_client_name, product_name) {
 
      httpApplycopy(page, pagesize, enterprise_client_name, product_name).then(
        (res) => {
          let data = res.data;
          if (data.code == 0) {
            // console.log(data);
            this.total = data.data.total;
            this.tableData = data.data.list;
          } else {
            this.$message(data.msg);
          }
        }
      );
    },
  },
  filters: {
    formatDate(time) {
      var data = new Date(time * 1000);
      return formatDate(data, "yyyy-MM-dd hh:mm:ss");
    },
  },
  mounted() {
    this._httpApplycopy(this.npage, this.pagesize);
  },
};
</script>

<style lang="scss" scoped>
.application_draft {
  .top {
    border-bottom: 2px solid #ccc;
    padding-bottom: 10px;
  }
  .main {
    .search {
      display: flex;
      flex-wrap: wrap;
      margin-top: 20px;
      .search_son {
        display: flex;
        margin-right: 10px;
        width: 200px;
        margin-bottom: 5px;
        .input,
        .select {
          display: inline-block;
          height: 28px;
          line-height: 28px;
          width: 100px;
        }
        &.time {
          width: 300px;
        }
        &.btn {
          width: 56px;
        }
        i {
          font-size: 24px;
          line-height: 30px;
          cursor: pointer;
        }
        &.refresh {
          line-height: 30px;
        }
      }
    }
    .search_btn {
      margin: 10px 0;
    }
    .look {
      color: #62b3ff;
      cursor: pointer;
      margin: 0 5px;
    }
    .page_footer {
      display: flex;
      justify-content: flex-end;
      margin: 20px;
    }
    /deep/ .el-table th {
      background-color: #f2f6fc !important;
    }
  }
}
</style>